import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import '@fontsource-variable/inter/wght.css'
import '@fontsource-variable/geist/wght.css'
import '@fontsource/playfair-display/latin-400.css'
import '@fontsource/playfair-display/latin-ext-400.css'
import '@fontsource/playfair-display/latin-600.css'
import '@fontsource/playfair-display/latin-ext-600.css'
import './fonts.css'
import './icons.css'
import './theme.css'
import './shell.css'

const root = document.getElementById('root')
if (!root) throw new Error('index.html is missing #root')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
